<template lang="pug">
    .counter-widget
        header.header
            .level
                .level-left
                    .title.is-4
                        span.icon.is-medium
                            i.fas.fa-calculator
                        span Forecast Counter
                .level-right
                    .title.tags.has-addons
                        span.tag.has-text-weight-bold.is-black {{ total.all }}
                        span.tag.has-text-weight-bold.is-success {{ total.success }}
                        span.tag.has-text-weight-bold.is-danger {{ total.failure }}
        .columns.data-list.is-mobile.is-multiline.is-gapless
            .column.is-full
                .container
                    DateRangePicker(
                        ref="picker"
                        v-model="dateRange"
                        :opens="opens"
                        :maxDate="maxDate"
                        :singleDatePicker="singleDatePicker"
                        :timePicker="timePicker"
                        :timePicker24Hour="timePicker24Hour"
                        :showWeekNumbers="showWeekNumbers"
                        :showDropdowns="showDropdowns"
                        @update="updateRange")
                        template(v-slot:input="picker" style="min-width: 350px;") {{ picker.startDate | date }} - {{ picker.endDate | date }}
            .column.is-full
                .accordion
                    .card(v-for="(date, i) in bets" :key="date.createdAt")
                        label.card-header.level.is-mobile(:for="`content-${i}`")
                            .level-left.has-text-weight-bold {{ dateFormat(date.createdAt) }}
                            .level-right.has-text-weight-bold {{ date.total }}
                        input.is-hidden(type="checkbox" :id="`content-${i}`" :checked="i === 0")
                        .card-content
                            .data-item(v-for="item in date.bets")
                                .level
                                    .level-left
                                        .level-item
                                            span.has-text-weight-bold {{ item.bet }}
                                    .level-right
                                        .level-item.tags.has-addons
                                            span.tag.has-text-weight-bold.is-success Success: {{ item.success }}
                                            span.tag.has-text-weight-bold.is-danger Failure: {{ item.failure }}
</template>

<script>
import moment from "moment";
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";

export default {
  name: "CounterWidget",
  components: { DateRangePicker },
  data() {
    return {
      opens: "right",
      maxDate: new Date(),
      timePicker: false,
      timePicker24Hour: false,
      singleDatePicker: false,
      showWeekNumbers: false,
      showDropdowns: false,
      appentToBody: true,
      dateRange: {
        startDate: moment().subtract(7, "days"),
        endDate: moment()
      }
    };
  },
  props: ["bets"],
  computed: {
    total() {
      const total = this.bets.reduce(
        (acc, row) => {
          return row.bets.reduce((counter, bet) => {
            return {
              success: counter.success + bet.success,
              failure: counter.failure + bet.failure
            };
          }, acc);
        },
        { success: 0, failure: 0 }
      );
      return {
        ...total,
        all: total.success + total.failure
      };
    }
  },
  methods: {
    updateRange(range) {
      this.$emit("range", range);
    },
    dateFormat(date) {
      return moment(date).format("YYYY-MM-DD");
    }
  },
  filters: {
    date(value) {
      if (!value) return "";

      let options = { year: "numeric", month: "long", day: "numeric" };
      return Intl.DateTimeFormat("en-US", options).format(value);
    }
  },
  mounted() {
    this.$emit("range", this.dateRange);
  }
};
</script>

<style lang="scss" scoped>
.counter-widget {
  position: relative;
  display: block;
  width: 100%;
  background: linear-gradient(180deg, #0bab64 0%, #3bb78f 100%);
  border-radius: 5px;

  .opacity {
    opacity: 0.8;
  }

  .header {
    position: relative;
    padding-bottom: 0.3rem;
    overflow: hidden;
    .level {
      padding: 1rem;
      .title {
        display: flex;
        justify-content: center;
        align-items: center;
        color: $defaultColor;

        .icon {
          margin-right: 0.5rem;
        }
      }
    }
  }

  .data-list {
    margin: 1rem 0 0;
    .container {
      padding: 0.5rem;
      .vue-daterange-picker {
        width: 100%;
        & /deep/ .form-control {
          border-radius: 3px;
          background: rgba(255, 255, 255, 0.35);
          color: #000;
          transition: all 0.2s linear;
          &:hover {
            background: rgba(255, 255, 255, 0.5);
          }
        }
        & /deep/ .daterangepicker {
          top: 2rem;
          .calendars {
            display: flex;
            .ranges {
              color: #000;
            }
          }
        }
      }
    }

    .card {
      box-shadow: none;
      background-color: transparent;
      .card-content {
        padding: 0.5rem 0;
        display: none;
        box-shadow: none;
      }
      label + input[type="checkbox"]:checked + .card-content {
        display: block;
      }
      .card-header {
        color: $white;
        padding: 0.5rem 0.7rem;
        margin: 0;
        box-shadow: none;
        cursor: pointer;
        background-color: transparent;
        &:not(:last-child) {
          border-bottom: 1px solid $white;
        }
        &:hover {
          background-color: rgba(225, 255, 255, 0.35);
        }
      }
      .card-content {
        padding: 0;
        .data-item {
          padding: 0.7rem;
          &:nth-child(odd) {
            background-color: rgba(255, 255, 255, 0.1);
          }
          &:nth-child(even) {
            background-color: rgba(255, 255, 255, 0.2);
          }
        }
      }
    }
  }
}
</style>
